import type {DefaultOptions} from '../../../types';
import type {TextWithMetadataValueEditorLocalizations, TextWithMetadataValueEditorModel, TextWithMetadataValueEditorOptions} from './types';

/**
 * @ngdoc constant
 * @name TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.text-with-metadata
 *
 * @description
 * For description see {@link TextWithMetadataValueEditorOptions}
 *
 * ```javascript
 * {
 *      customEmptyAsNullCheck: ({value}: {value: TextWithMetadataValueEditorModel}) => (value?.row ?? '').length === 0
 * }
 * ```
 */
export const TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<TextWithMetadataValueEditorOptions> = {
    customEmptyAsNullCheck: ({value}: {value: TextWithMetadataValueEditorModel}) => (value?.row ?? '').length === 0
};

/**
 * @ngdoc constant
 * @name TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.text-with-metadata
 *
 * @description
 * ```
 * {
 *      startsWith: 'Starts with',
 *      equals: 'Equals',
 *      metadataSelectLabel: '',
 *      currentSelectValue: 'Currently selected value',
 *      mainInputLabel: '',
 *      description: ''
 * }
 * ```
 */
export const TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<TextWithMetadataValueEditorLocalizations>({
    startsWith: 'Starts with',
    equals: 'Equals',
    metadataSelectLabel: '',
    currentSelectValue: 'Currently selected value',
    mainInputLabel: '',
    description: ''
});